import { render, staticRenderFns } from "./dayWiseSlots.vue?vue&type=template&id=53cb8f82&scoped=true"
import script from "./dayWiseSlots.vue?vue&type=script&lang=js"
export * from "./dayWiseSlots.vue?vue&type=script&lang=js"
import style0 from "./dayWiseSlots.vue?vue&type=style&index=0&id=53cb8f82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb8f82",
  null
  
)

export default component.exports